export default "__VITE_PUBLIC_ASSET__0aa2e83d__"